import { render } from "./ExcelEditor.vue?vue&type=template&id=3817cec9&scoped=true"
import script from "./ExcelEditor.vue?vue&type=script&lang=js"
export * from "./ExcelEditor.vue?vue&type=script&lang=js"

import "./ExcelEditor.vue?vue&type=style&index=0&id=3817cec9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3817cec9"]])

export default __exports__